import axios from 'axios'

export const newsLetterSubscription = async (email: string, lang: string) => {
	try {
		const data = new URLSearchParams()
		data.append('user-id', email)
		data.append('lng', lang)

		const response = await axios.post(
			`${process.env.NEXT_PUBLIC_BACKEND_URL}/hotels/subscription`,
			data,
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			}
		)

		return response.data
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.error(
				'Newsletter subscription error:',
				error.response?.data || error.message
			)
		}
	}
}

export type PriceAlertSubscriptionData = {
	tab: string
	vert: string
	'location-name': string
	'hotel-country': string
	'state-code': string
	'country-code'?: string
	'check-in-date': string
	'check-out-date': string
	'destination-id'?: string
	'destination-key': string | undefined
	destination: string
	city: string
	rooms: number
	adults: string
	children: string
	los: number
	dta: number
	b?: string
	f?: string
	buid?: string
	email: string
	lng: string
	currency: string
}

export const priceAlertSubscription = async (
	data: PriceAlertSubscriptionData
) => {
	try {
		const formData = new FormData()

		Object.entries(data).forEach(([key, value]) => {
			if (Array.isArray(value)) {
				value.forEach((item) => formData.append(key, item))
			} else if (value !== undefined) {
				formData.append(key, value.toString())
			}
		})

		const response = await axios.post(
			`${process.env.NEXT_PUBLIC_BACKEND_URL}/hotels/meta-subscription`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			}
		)

		return response.data
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.error(
				'Price alert subscription error:',
				error.response?.data || error.message
			)
		}
	}
}
